import { lazy } from 'react'

const AboutPage = lazy(() => import('../views/AboutPage/About'))
const HomePage = lazy(() => import('../views/HomePage/Home'))
const Technology = lazy(() => import('../views/TechnologiesPage/Technology'))
const KnowledgeBase = lazy(() => import('../views/KnowledgeBase/KnowledgeBase'))
const OurBlog = lazy(() => import('../views/BlogPage/Blog'))
const ContactPage = lazy(() => import('../views/ContactUs/Contact'))
const ProductSolution = lazy(
  () => import('../views/ProductsSolution/ProductsSolution')
)
const Optimization = lazy(() => import('../views/Optimization/Optimization'))
const BlogDetail = lazy(() => import('../views/BlogPage/BlogDetails'))
const KnowledgeDetail = lazy(
  () => import('../views/KnowledgeBase/KnowledgeBaseDetails')
)

export const rootRoutes = [
  { pathname: '/', name: 'Home', component: HomePage },
  { pathname: '/about', name: 'About', component: AboutPage },
  { pathname: '/technologies', name: 'Tech', component: Technology },
  { pathname: '/knowledge', name: 'Knowledge', component: KnowledgeBase },
  { pathname: '/knowledge/:id', name: 'Knowledge', component: KnowledgeDetail },
  { pathname: '/blog', name: 'Blog', component: OurBlog },
  { pathname: '/blog/:id', name: 'Blog-Detail', component: BlogDetail },
  { pathname: '/contact-us', name: 'Contact', component: ContactPage },
  {
    pathname: '/product-solution',
    name: 'Product Solutin',
    component: ProductSolution,
  },
  {
    pathname: '/protection',
    name: 'Protect & Optimization',
    component: Optimization,
  },
]
